export type HelpCenterArticle = {
  id: string
  title: string
}

export type HelpCenterSubCategory = {
  id: string
  title: string
  slug: string
  articles: HelpCenterArticle[]
}

export type HelpCenterCategory = {
  id: string
  title: string
  slug: string
  order: number | null
  subCategories: HelpCenterSubCategory[]
}

export type HelpCenterResponse = {
  categories: HelpCenterCategory[]
}

export type HelpCenterArticleDetail = {
  id: string
  title: string
  description: string
  body: string
}

export type HelpCenterArticleNavState = {
  from: {
    categorySlug: string
    categoryTitle: string
  }
}

export function isHelpCenterArticleNavState(value: unknown): value is HelpCenterArticleNavState {
  if (value === null || typeof value !== "object") return false
  const from = (value as { from?: unknown }).from
  if (from === null || typeof from !== "object") return false
  const { categorySlug, categoryTitle } = from as { categorySlug?: unknown; categoryTitle?: unknown }
  return typeof categorySlug === "string" && typeof categoryTitle === "string"
}
